import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IResponseData } from '../../interfaces/response-data';
import { IAvailabilityDates, IAvailabilityDatesArray } from '../../interfaces/availability-dates';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { map } from 'rxjs/operators';
import { IGuestsData } from '../../interfaces/guests-data';

@Injectable({
  providedIn: 'root'
})
export class AvailabilityDatesService {
  selectedCityId: BehaviorSubject<number> = new BehaviorSubject(null);
  guestsData: BehaviorSubject<IGuestsData> = new BehaviorSubject(null);

  constructor(private readonly http: HttpClient) {}

  getAvailabilityDates(
    cityId: number,
    start: string,
    end: string,
    guests: number,
    childrenAges: string,
    propertyId: number,
    unitGroupId: number = null
  ): Observable<IResponseData<IAvailabilityDates>> {
    let availabilityEndpointUrl =
      `${environment.apiBaseUrl}/public/calendar-availabilities?start=${start}&end=${end}&adults=${guests}&cityId=${cityId}&uncached=false` +
      (childrenAges && childrenAges.length ? `&childrenAges=${childrenAges}` : '') +
      (propertyId ? `&propertyId=${propertyId}` : '') +
      (unitGroupId ? `&unitGroupId=${unitGroupId}` : '');

    return this.http.get<IResponseData<IAvailabilityDatesArray>>(availabilityEndpointUrl).pipe(
      map((response) => {
        /*
         * We need to format the payload
         * It should have the same properties/structure that the payload returned from the getAvailabilityDates method has
         * */
        response.payload = this.formatPayload(response.payload);
        return response;
      })
    );
  }

  formatPayload(payload: IAvailabilityDatesArray) {
    const formattedPayload = {};

    if (payload.length) {
      payload.map((element) => {
        const { date } = element;
        const yearMonth = date.slice(0, 7);
        formattedPayload[yearMonth] = formattedPayload[yearMonth] || [];
        formattedPayload[yearMonth].push({
          date: element.date,
          isBookable: element.bookable
        });
      });
    }

    return formattedPayload;
  }
}
